import { createAction, props } from '@ngrx/store';
import { PagingTokenFixed } from 'src/app/shared/models/core';
import { PermanentCandidateItemModel } from 'src/app/shared/models/permanent-candidate-item.model';
import { PermCandidatesGridFetchArgs } from '../models/perm-post-offer-candidates-grid-filter.model';
import { PermCandidatesGridMode } from '../../../accountmanagers/candidates/permanent/permanent-candidates-grid.component';

export const initializePermanentCandidatesPreStartPage = createAction(
    '[Permanent Candidates Component] Initialize Permanent Candidates Pre-Start Dashboard'
);

export const initializePermanentCandidatesPreStartSuccess = createAction(
    '[Permanent Candidates API] Initialize Permanent Candidates Pre-Start Success',
    props<{ candidates: PagingTokenFixed<PermanentCandidateItemModel[]> }>()
);

export const initializePermanentCandidatesPreStartFailure = createAction(
    '[Permanent Candidates API] Initialize Permanent Candidates Pre-Start Failure',
    props<{ error: any }>()
);

export const loadPermanentCandidatesPreStartPage = createAction(
    '[Permanent Candidates Component] Load Permanent Candidates Pre-Start Dashboard',
    props<{ args: PermCandidatesGridFetchArgs }>()
);

export const loadPermanentCandidatesPreStartSuccess = createAction(
    '[Permanent Candidates API] Load Permanent Candidates Pre-Start Success',
    props<{ candidates: PagingTokenFixed<PermanentCandidateItemModel[]> }>()
);

export const loadPermanentCandidatesPreStartFailure = createAction(
    '[Permanent Candidates API] Load Permanent Candidates Pre-Start Failure',
    props<{ error: any }>()
);

export const initializePermanentCandidatesConfirmedPage = createAction(
    '[Permanent Candidates Component] Initialize Permanent Candidates Confirmed Dashboard'
);

export const initializePermanentCandidatesConfirmedSuccess = createAction(
    '[Permanent Candidates API] Initialize Permanent Candidates Confirmed Success',
    props<{ candidates: PagingTokenFixed<PermanentCandidateItemModel[]> }>()
);

export const initializePermanentCandidatesConfirmedFailure = createAction(
    '[Permanent Candidates API] Initialize Permanent Candidates Confirmed Failure',
    props<{ error: any }>()
);

export const loadPermanentCandidatesConfirmedPage = createAction(
    '[Permanent Candidates Component] Load Permanent Candidates Confirmed Dashboard',
    props<{ args: PermCandidatesGridFetchArgs }>()
);

export const loadPermanentCandidatesConfirmedSuccess = createAction(
    '[Permanent Candidates API] Load Permanent Candidates Confirmed Success',
    props<{ candidates: PagingTokenFixed<PermanentCandidateItemModel[]> }>()
);

export const loadPermanentCandidatesConfirmedFailure = createAction(
    '[Permanent Candidates API] Load Permanent Candidates Confirmed Failure',
    props<{ error: any }>()
);

export const refreshPermanentCandidatesPreStartPage = createAction(
    '[Permanent Candidates Component] Refresh Permanent Candidates Pre-Start Dashboard'
);

export const refreshPermanentCandidatesSuccess = createAction(
    '[Permanent Candidates API] Refresh Permanent Candidates Success',
    props<{ candidates: PagingTokenFixed<PermanentCandidateItemModel[]> }>()
);

export const refreshPermanentCandidatesFailure = createAction(
    '[Permanent Candidates API] Refresh Permanent Candidates Failure',
    props<{ error: any }>()
);

export const clearPostOfferCandidatesInformation = createAction(
    '[Permanent Candidates Component] Clear Permanent Candidates Pre-Start/Confirmed Dashboard'
);

export const exportPermanentCandidates = createAction(
    '[Permanent Candidates Component] Export Permanent Candidates Post Offer Dashboard',
    props<{ permanentJobOfferIds: number[]; gridMode: PermCandidatesGridMode }>()
);

export const exportPermanentCandidatesSuccess = createAction(
    '[Permanent Candidates API] Export Permanent Candidates Post Offer Dashboard Success'
);

export const exportPermanentCandidatesFailure = createAction(
    '[Permanent Candidates API] Export Permanent Candidates Post Offer Dashboard Failure',
    props<{ error: any }>()
);

export const setJobOfferStatusToConfirmed = createAction(
    '[Permanent Candidates Component] Set Job Offer Status To Confirmed',
    props<{ jobOfferId: number }>()
);

export const setJobOfferStatusToConfirmedSuccess = createAction(
    '[Permanent Candidates API] Set Job Offer Status To Confirmed Success'
);

export const setJobOfferStatusToConfirmedFailure = createAction(
    '[Permanent Candidates API] Set Job Offer Status To Confirmed Failure',
    props<{ error: any }>()
);
